import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.07));
  z-index: 999;
  overflow: visible !important;
  background: #172B4D;
  color: white;
  font-size: 16px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-left: 16px;
`;

export const GroupBy = styled.div`
  white-space: nowrap;
  margin-right: 10px;
  margin-top: 3px;
`;

export const ColText = styled.span`
  margin-left: 10px;
`;
